/* Moneglia — catalogue boutique : filtres, compteur, ajout au panier */
(function () {
  function init() {
    document.querySelectorAll('[data-mng-filters]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';

      var grid = document.querySelector('[data-mng-grid]');
      if (!grid) return;

      var count = root.querySelector('[data-mng-count]');
      var cards = [].slice.call(grid.children);
      var singular = root.getAttribute('data-singular') || 'piece';
      var plural = root.getAttribute('data-plural') || 'pieces';

      function render(n) {
        if (!count) return;
        var s = String(n);
        if (s.length < 2) s = '0' + s;
        count.textContent = s + ' ' + (n > 1 ? plural : singular);
      }
      render(cards.length);

      root.addEventListener('click', function (e) {
        var btn = e.target.closest('.mng-chip');
        if (!btn) return;
        var f = btn.getAttribute('data-filter');
        root.querySelectorAll('.mng-chip').forEach(function (b) {
          b.classList.toggle('is-on', b === btn);
        });
        var n = 0;
        cards.forEach(function (c) {
          var show = (f === 'tout') || c.getAttribute('data-type') === f;
          c.hidden = !show;
          if (show) n++;
        });
        render(n);
      });

      grid.addEventListener('submit', function (e) {
        var form = e.target.closest('[data-mng-atcform]');
        if (!form) return;
        e.preventDefault();
        var btn = form.querySelector('[data-mng-atc]');
        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' }
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (btn) {
              btn.classList.add('is-done');
              btn.textContent = btn.getAttribute('data-label-done') || 'ajouté';
              setTimeout(function () {
                btn.classList.remove('is-done');
                btn.textContent = btn.getAttribute('data-label') || 'ajouter au panier';
              }, 1800);
            }
            document.dispatchEvent(new CustomEvent('mng:cart:added'));
          })
          .catch(function () { form.submit(); });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();
